/**
 * @file Re-exports the platform release alert banner.
 */
import ReleaseAlert from "./ReleaseAlert";

export default ReleaseAlert;
